import script from "./PatientCommentTeaser.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientCommentTeaser.vue?vue&type=script&setup=true&lang=js"

import "./PatientCommentTeaser.vue?vue&type=style&index=0&id=efb8a510&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb8a510"]])

export default __exports__